import { mailApiGet, mailApiPost } from "./client";
import type { MailSnoozeEntry, MailSnoozeWoke } from "@/lib/snooze/constants";

export type SnoozeListResponse = {
  success: boolean;
  accountId: number;
  snoozes: MailSnoozeEntry[];
  woke?: MailSnoozeWoke[];
};

export function fetchMailSnoozes(params: { accountId: number; folder?: string }) {
  const qs = new URLSearchParams();
  qs.set("accountId", String(params.accountId));
  if (params.folder) qs.set("folder", params.folder);
  return mailApiGet<SnoozeListResponse>(`imap/snooze.php?${qs.toString()}`);
}

export function setMailSnooze(params: {
  accountId: number;
  folder: string;
  uid: number;
  until: string;
  subject?: string;
  holdFolder?: string | null;
}) {
  // Gmail local = MySQL rapide ; timeout court pour ne plus attendre un OAuth/IMAP fantôme.
  return mailApiPost<{ success: boolean; snooze: MailSnoozeEntry }>(
    "imap/snooze.php",
    {
      accountId: params.accountId,
      folder: params.folder,
      uid: params.uid,
      until: params.until,
      subject: params.subject,
      holdFolder: params.holdFolder ?? undefined,
    },
    { timeoutMs: 20_000 }
  );
}

export function cancelMailSnooze(params: {
  accountId: number;
  folder: string;
  uid: number;
}) {
  // Gmail local = DELETE MySQL seul ; timeout court (même piège OAuth si vieux code serveur).
  return mailApiPost<{ success: boolean; uid: number; cancelled: boolean }>(
    "imap/snooze.php",
    {
      accountId: params.accountId,
      folder: params.folder,
      uid: params.uid,
      cancel: true,
    },
    { timeoutMs: 20_000 }
  );
}
